import z from 'zod';
import {userModuleDbSchema} from './userModuleDbSchema';
import {userPermissionSchema} from './userPermissionSchema';
import {firestoreTimestampSchema} from '../_other/firestore';

/**
 * Firestore representation of a user document.
 * Dates are stored as Timestamp/Date at the database level.
 */
export const userDbSchema = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  photoUrl: z.string().optional(),
  createdAt: firestoreTimestampSchema,
  lastLogin: firestoreTimestampSchema,
  roles: z.array(userPermissionSchema).default([]),
  notStudent: z.boolean().optional(),
  backgroundImageUrl: z.string().optional(),
  disableAnimation: z.boolean().default(false),
  soundVolume: z.number().optional(),
  clickSoundUrl: z.string().optional(),
  checkSoundUrl: z.string().optional(),
  dropdownSoundUrl: z.string().optional(),
  switchSoundUrl: z.string().optional(),
  slideSoundUrl: z.string().optional(),
  groupIds: z.array(z.string()).default([]),
  inviteToGroupIds: z.array(z.string()).default([]),
  selectedModules: z.array(userModuleDbSchema).default([]),
  lastStreakDate: z.string().optional(),
  currentStreak: z.number().default(0),
  highestStreak: z.number().default(0),
});

export type UserDb = z.infer<typeof userDbSchema>;
